"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNATTENDED_EDIT_PROVENANCE = exports.EditProvenanceSchema = exports.EditAgencySchema = exports.EditAgency = void 0;
const zod_1 = require("zod");
const authentication_types_1 = require("./authentication.types");
var EditAgency;
(function (EditAgency) {
    EditAgency["Ui"] = "ui";
    EditAgency["Mcp"] = "mcp";
    EditAgency["Agent"] = "agent";
    EditAgency["Workflow"] = "workflow";
    EditAgency["System"] = "system";
})(EditAgency || (exports.EditAgency = EditAgency = {}));
exports.EditAgencySchema = zod_1.z.nativeEnum(EditAgency);
exports.EditProvenanceSchema = zod_1.z.object({
    actorUserId: zod_1.z.string().nullable(),
    actorType: authentication_types_1.ActorTypeSchema.nullable(),
    agency: exports.EditAgencySchema,
});
exports.UNATTENDED_EDIT_PROVENANCE = {
    actorUserId: null,
    actorType: null,
    agency: EditAgency.System,
};
//# sourceMappingURL=edit-provenance.types.js.map